// src/pages/login.tsx
import { useLogin } from "@refinedev/core";
import {
  Layout as AntdLayout,
  Card,
  Typography,
  Form,
  Input,
  Button,
  theme,
  notification,
} from "antd";
import { useEffect } from "react";

const { Title } = Typography;
const { useToken } = theme;

export const Login: React.FC = () => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const { mutate: login } = useLogin();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    // Set page title
    document.title = `ログイン | ${import.meta.env.VITE_APP_NAME}`;
  }, []);

  return (
    <>
      {contextHolder}
      <AntdLayout
      style={{
        background: token.colorBgContainer,
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        style={{
          width: 400,
          padding: "24px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <Title level={3} style={{ margin: 0, color: token.colorPrimary }}>
            {import.meta.env.VITE_APP_NAME}
          </Title>
          <Typography.Text type="secondary">
            管理者ログイン
          </Typography.Text>
        </div>
        <Form<{ email: string; password: string }>
          form={form}
          layout="vertical"
          onFinish={async (values) => {
            await login(values);
            api.success({
              message: 'ログイン成功',
              description: 'ダッシュボードへリダイレクトします',
              placement: 'topRight',
            });
          }}
        >
          <Form.Item
            name="email"
            label="メールアドレス"
            rules={[{ required: true, message: "メールアドレスを入力してください" }]}
          >
            <Input size="large" placeholder="example@example.com" />
          </Form.Item>
          <Form.Item
            name="password"
            label="パスワード"
            rules={[{ required: true, message: "パスワードを入力してください" }]}
          >
            <Input.Password size="large" placeholder="********" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              block
              style={{ marginTop: "24px" }}
            >
              ログイン
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </AntdLayout>
    </>
  );
};